import { toast } from "react-toastify";
import { API_DEVOLUCIONES } from "../views/MainLayout/components/shared/services/devoluciones";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialDevoluciones = []

export const devolucionesReducer = (state = initialDevoluciones, action) => {
    switch(action.type){
        case "devoluciones/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchDevoluciones = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_DEVOLUCIONES.getDevoluciones(page, search)
        const data = await response.data;
        dispatch({ type: 'devoluciones/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}